import { useEffect } from 'react';
import type { LocationsResponse } from 'src/apis/snam-bid-collector/types';
import { useAxios } from 'src/hooks/use-axios';
import type { BidCollectorRootRequest } from 'src/pages/snam-bid-collector/use-bid-collector';

type RequestOptions = {
  url: string;
};

export function useLocations(bidCollectorRoot: BidCollectorRootRequest) {
  const locationsRequest = useAxios(
    (axios, baseConfig, { url }: RequestOptions) =>
      axios.request<LocationsResponse>({
        url,
        ...baseConfig,
      }),
    { neededOnPageLoad: true }
  );

  useEffect(() => {
    if (
      !bidCollectorRoot.response ||
      !bidCollectorRoot.response.data._links.getLocations
    ) {
      return;
    }

    locationsRequest.execute({
      url: bidCollectorRoot.response.data._links.getLocations.href,
    });

    // oxlint-disable-next-line exhaustive-deps
  }, [bidCollectorRoot.response]);

  return locationsRequest;
}
export type LocationsRequest = ReturnType<typeof useLocations>;
